import CockpitPanelHeader from '@components/cockpit/panels/CockpitPanelHeader';
import Panel from '@components/cockpit/panels/Panel';
import SensorEditingPanel from '@components/cockpit/panels/sensorInstallation/sensorEditing/SensorEditingPanel';
import {
  SensorInstallationProvider,
  useSensorInstallationContext,
} from '@components/cockpit/panels/sensorInstallation/SensorInstallationContext';
import { SensorOverviewPanel } from '@components/cockpit/panels/sensorInstallation/SensorOverviewPanel';
import { useIntl } from 'react-intl';

const SensorInstallationPanelContent = () => {
  const { editedSensor } = useSensorInstallationContext();
  return editedSensor === null ? <SensorOverviewPanel /> : <SensorEditingPanel />;
};

export default function SensorInstallationPanel() {
  const { formatMessage } = useIntl();

  return (
    <SensorInstallationProvider>
      <Panel header={<CockpitPanelHeader label={formatMessage({ id: 'components.sidebar.SENSOR_INSTALLATION' })} />}>
        <SensorInstallationPanelContent />
      </Panel>
    </SensorInstallationProvider>
  );
}
